import React, { Dispatch, memo, SetStateAction, useState } from "react";
import { NavLink } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";

//import images
// import logo from "../assets/logo-logistics.svg";
import logoLight from "../assets/logo07-light.png";

//import Components
// import LanguageDropdown from "../../Components/Common/LanguageDropdown";
import FullScreenDropdown from "../components/common/FullScreenDropdown";
// import NotificationDropdown from "../components/common/NotificationDropdown";
import ProfileDropdown from "../components/common/ProfileDropdown";
import LanguageDropdown from "../components/common/LanguageDropdown";
// import LightDark from "../../Components/Common/LightDark";

interface Props {
  readonly headerClass: string;
  readonly setOpenMenu: Dispatch<SetStateAction<boolean>>;
  // readonly setOpenMenu: Dispatch<SetStateAction<boolean>>;
}

export default memo(function Header({ headerClass, setOpenMenu }: Props) {
  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  const toogleMenuBtn = () => {
    const windowSize = document.documentElement.clientWidth;
    //@ts-ignore
    if (windowSize > 767) {
      document?.querySelector(".hamburger-icon")?.classList.toggle("open");
      // setOpenMenu((prev) => !prev);
    }

    // For collapse horizontal menu
    document?.body?.classList?.contains("menu")
      ? document?.body?.classList?.remove("menu")
      : document?.body?.classList?.add("menu");

    //For collapse vertical menu
    // if (document.documentElement.getAttribute("data-layout") === "vertical") {
    //   if (windowSize < 1025 && windowSize > 767) {
    //     document.body.classList.remove("vertical-sidebar-enable");
    //     document.documentElement.getAttribute("data-sidebar-size") === "sm"
    //       ? document.documentElement.setAttribute("data-sidebar-size", "")
    //       : document.documentElement.setAttribute("data-sidebar-size", "sm");
    //   } else if (windowSize > 1025) {
    //     document.body.classList.remove("vertical-sidebar-enable");
    //     document.documentElement.getAttribute("data-sidebar-size") === "lg"
    //       ? document.documentElement.setAttribute("data-sidebar-size", "sm")
    //       : document.documentElement.setAttribute("data-sidebar-size", "lg");
    //   } else if (windowSize <= 767) {
    //     document.body.classList.add("vertical-sidebar-enable");
    //     document.documentElement.setAttribute("data-sidebar-size", "lg");
    //   }
    // }
    //
    // //Two column menu
    // if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
    //   document.body.classList.contains("twocolumn-panel")
    //     ? document.body.classList.remove("twocolumn-panel")
    //     : document.body.classList.add("twocolumn-panel");
    // }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                {/*<NavLink to="/" className="logo logo-dark">*/}
                {/*  <span className="logo-lg">*/}
                {/*    <img src={logo} alt="" height="17" />*/}
                {/*  </span>*/}
                {/*</NavLink>*/}

                <NavLink to="/" className="logo logo-light">
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="25" />
                  </span>
                </NavLink>
              </div>
              <button
                onClick={() => {
                  setOpenMenu((prev) => !prev);
                  toogleMenuBtn();
                }}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>

              {/*<SearchOption />*/}
            </div>

            <div className="d-flex align-items-center">
              <Dropdown
                isOpen={search}
                toggle={toogleSearch}
                className="d-md-none topbar-head-dropdown header-item"
              >
                <DropdownToggle
                  type="button"
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >
                  <i className="bx bx-search fs-22" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                  <Form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </Form>
                </DropdownMenu>
              </Dropdown>

              {/* LanguageDropdown */}
              <LanguageDropdown />

              {/* WebAppsDropdown */}
              {/*<WebAppsDropdown />*/}

              {/* MyCartDropdwon */}
              {/*<MyCartDropdown />*/}

              {/* FullScreenDropdown */}
              <FullScreenDropdown />

              {/* Dark/Light Mode set */}
              {/*<LightDark layoutMode={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />*/}

              {/* NotificationDropdown */}
              {/*<NotificationDropdown />*/}

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
});
